import React from 'react';
import {Link} from 'react-router-dom';
import {FaBars, FaSearch, FaHome, FaVideo, FaTimes, FaFacebook, FaTwitter, FaLinkedin} from 'react-icons/fa'
import Form from '../Form/Form';
import { motion } from 'framer-motion';
import {useGlobalContext} from '../../Utils/ContextApi'
import { navlinks } from './navlinks';
import './navbar.css'
import Sidebar from '../Sidebar/Sidebar';

function Navbar() {
  const {searchBarIcon, searchBar, isSidebarOpen, openSidebar, closeSidebar} = useGlobalContext()


  const style={
    display:'flex',
    justifyContent:'space-around',
    alignItems:'center',
    gap:"30px"
  }
  return(
  <header>
    <nav className='navbar'>
      <div style={style}>
      <Link to='/' style={{textDecoration:'none', color:'white'}}>
        <motion.h1
          initial={{opacity:0}}
          animate={{opacity:1}}
          transition={{duration:0.5, delay:0.5}}><span style={{color:"gold"}}>Fo</span>Movie</motion.h1></Link>
      <motion.div className='navlink-container'
         initial={{opacity:0}}
         animate={{opacity:1}}
         transition={{duration:0.5, delay:1.5}}>
        {navlinks.map((link)=>{
          return(
            <Link to={`${link.url}`} key={link.name} className="nav-link">{link.name}</Link> 
          )
        })}
      </motion.div>
      </div>
      <motion.div className='icon'
         initial={{opacity:0}}
         animate={{opacity:1}}
         transition={{duration:0.5, delay:1.2}}>
      <FaBars onClick={openSidebar} className='modal-btn'/>
      <Link to='/search' className='icon' style={{color:'#fff'}}><FaSearch /></Link>
      </motion.div>
    </nav>
    <Sidebar />
    </header>
  )
}

export default Navbar